import React from 'react';

const IconLoader = () => <div className="logo">S</div>;

export default IconLoader;
